const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

export const isZipCode = (zip: string) => {
  return ZIP_REGEX.test(zip);
};
